export default __webpack_public_path__ + "images/rosabandet/sub-nav-bullets.png";